import * as React from "react";
import { NumericInput } from "../../externals";
import { setValue } from "../utils";
export class MinutesPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChangeMinutes = (value) => {
            let cron = Object.assign({}, this.props.cron);
            cron.minutes = "0/" + value;
            this.props.onChange(cron);
        };
    }
    render() {
        let currentCron = this.props.cron;
        return (React.createElement("div", { id: "minutesPanel", className: "tab-option-inline" },
            React.createElement("label", { className: "option-item" }, "Every"),
            React.createElement(NumericInput, { allowNumericCharactersOnly: true, max: 59, min: 1, className: "option-item", onValueChange: (value) => this.onChangeMinutes(value.toString()), value: setValue(true, currentCron.minutes) }),
            React.createElement("label", null, "minute(s)")));
    }
}
//# sourceMappingURL=MinutesPanel.js.map